<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Department Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryDeptFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryDeptFilterForm"
                              v-model="filters.dept"
                              :label="labels.dept"
                              :error-messages="errors.collect('dept')"
                              data-vv-name="dept"
                              :data-vv-as="labels.dept"
                              v-validate="'entry|max:20'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearDeptFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="deDeptFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-card>
            <v-card-text>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="deptList"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                :server-items-length="totalItemsDept"
                item-key="value"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mr-2" @click="doSelect('All', 'value')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mr-2" @click="doSelect('', 'value')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        dept: 'Department'
      },
      filters: {
        dept: undefined
      },
      headers: [
        { text: 'Department', align: 'left', value: 'value' },
        { text: 'Description', align: 'left', value: 'label' }
      ],
      deptList: [],
      loading: false,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      totalItemsDept: 0
    }
  },
  mounted() {
    this.doClearDeptFilters()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.deptList = []
      try {
        const apiURI = this.$store.state.commons.menu.getDeptListFilter
        if (apiURI) {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItemsDept = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.deptList = []
              this.items = []
              data.map((deptObj) => {
                const convertList = {
                  key: deptObj.dept,
                  value: deptObj.dept,
                  label: deptObj.deptDesc
                }
                if (this.checkedItems.includes(deptObj.dept)) {
                  const deptList = {
                    key: deptObj.dept,
                    branch: deptObj.dept,
                    brnDesc: deptObj.deptDesc
                  }
                  this.selectedItems.push(deptList)
                }
                this.deptList.push(convertList)
              })
            }
          }
        }
      } catch (e) {}
      this.loading = false
    },
    closeDialog() {
      this.filters.dept = ''
      this.$emit('close')
    },
    doClearDeptFilters() {
      this.filters.dept = ''
      this.doFetch()
    },
    deDeptFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryDeptFilterForm').then((result) => {
        if (result) {
          this.doFetch()
        }
      })
    }
  },
  watch: {
    'pagination': function (value) {
      this.doFetch()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin, helpListMixin],
  props: {
    menu: Object
  }
}
</script>

<style>
</style>
